import contactType from 'helpers/contact_type';

angular.module('gym.calendar').directive('eventScheduleGeneral', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/calendar/events/edit_event_schedule/general/event_schedule_general.html.slim'),
    scope: {
      gym: '=',
      event: '=',
      classrooms: '=',
      styles: '=',
      eventTypes: '=',
      permissions: '=',
      bookings: '=',
      recurringBookings: '=',
      onEdit: '&',
      cancelEdit: '&',
      save: '&',
      delete: '&',
      reloadEvent: '&',
      showAllBookingsAvailable: '&',
      showAllBookings: '&'
    },
    controller: ["$scope", "$stateParams", "$window", "$http", "$modal", "ReactModal", "flash", "EventService", "FeatureAvailabilityService", "ContactBadgeService", "isInteger", function($scope, $stateParams, $window, $http, $modal, ReactModal, flash, EventService, FeatureAvailabilityService, ContactBadgeService, isInteger) {
      var eventId, gym, gymId;
      gym = $scope.gym;
      gymId = $stateParams.gymId;
      eventId = $stateParams.eventId;
      $scope.attendanceFeatureAvailable = FeatureAvailabilityService.isAvailable('attendance');
      $scope.instructorNames = function() {
        return EventService.eventInstructorNames($scope.event);
      };
      $scope.eventStyleNames = function() {
        return EventService.eventStyleNames($scope.event, $scope.styles);
      };
      $scope.eventTypeNames = function() {
        return EventService.eventTypeNames($scope.event, $scope.eventTypes);
      };
      $scope.eventStatus = EventService.status($scope.event);
      $scope.websiteHiddenLabel = EventService.websiteHiddenLabel();
      $scope.isEventInPast = function() {
        return moment($scope.event.event_date).isBefore(moment().tz($scope.gym.tz), 'day');
      };
      $scope.edit = function() {
        $scope.onEdit();
        return $modal.open({
          template: require('templates/gyms/calendar/events/edit_event_schedule/general/edit_event_schedule_general.html.slim'),
          windowClass: 'drawer__wrapper',
          backdropClass: 'modal-backdrop--drawer',
          controller: 'EditEventScheduleGeneralCtrl',
          resolve: {
            params: function() {
              return {
                event: $scope.event.clone(),
                classrooms: $scope.classrooms,
                styles: $scope.styles,
                eventTypes: $scope.eventTypes,
                save: $scope.save,
                cancelEdit: $scope.cancelEdit
              };
            }
          }
        });
      };
      if ($stateParams.editSection && $scope.permissions.manage_events) {
        $scope.edit();
      }
      $scope.getContactBadge = function(type, status) {
        return ContactBadgeService.get(type, status);
      };
      $scope.contactType = function(type) {
        return contactType(type);
      };
      $scope.waitlistPlacesAvailable = function() {
        return EventService.waitlistPlacesAvailable($scope.event);
      };
      $scope.addToWaitlist = function(contact) {
        var url;
        $scope.search = '';
        url = `/gyms/${gymId}/calendar/events/${eventId}/waitlist_attendees`;
        return $http.post(url, {
          contact_id: contact.id
        }).then(function(response) {
          $scope.reloadEvent();
          return flash.success = `${response.data.contact_name} added to waitlist`;
        }, function(response) {
          if (response.data.error_message) {
            return flash.error = response.data.error_message;
          }
        });
      };
      $scope.removeFromWaitlist = function(waitlist) {
        return EventService.removeFromWaitlist(waitlist).then(function() {
          return $scope.reloadEvent();
        });
      };
      $scope.changeWaitlistPosition = function(waitlist, change) {
        return EventService.changeWaitlistPosition(waitlist, change).then(function() {
          return $scope.reloadEvent();
        });
      };
      $scope.bookNow = function(waitlist) {
        return EventService.bookNow(waitlist, $scope.event).then(function() {
          return $scope.reloadEvent();
        });
      };
      $scope.getRecurringBooking = function(contactId) {
        var ref;
        return (ref = $scope.recurringBookings) != null ? ref.find(function(item) {
          return item.contact_id === contactId;
        }) : void 0;
      };
      $scope.enableRecurringBookingsVisible = function(contactId) {
        return gym.gym_config.recurring_bookings_feature_enabled && $scope.event.all_events_count > 1 && !$scope.getRecurringBooking(contactId);
      };
      $scope.enableRecurringBookings = function(waitlist) {
        var modalInstance;
        modalInstance = ReactModal.open({
          component: 'EnableRecurringBookingsModal',
          props: {
            booking: waitlist,
            event: $scope.event.plain(),
            fromWaitlist: true
          }
        });
        return modalInstance.then(function() {
          return $scope.reloadEvent();
        });
      };
      return $scope.disableRecurringBookings = function(waitlist) {
        var modalInstance;
        modalInstance = ReactModal.open({
          component: 'DisableRecurringBookingsModal',
          props: {
            booking: waitlist,
            event: $scope.event.plain(),
            recurringBooking: $scope.getRecurringBooking(waitlist.contact_id)
          }
        });
        return modalInstance.then(function() {
          return $scope.reloadEvent();
        });
      };
    }]
  };
});
